import { useTheme } from "styled-components";
import { IModalProps } from "../../@interfaces";
import CloseButton from "../closebutton";
import { Content, Header, ModalContainer, Overlay } from "./style";



const BaseModal: React.FC<IModalProps> = ({ closeModal, children, width, height }) => {
  const theme = useTheme();

  return (
    <Overlay>
      <ModalContainer width={width} height={height}>
        <Header>
          <CloseButton handleClose={closeModal} color={theme.colors.black} />
        </Header>
        <Content>
          {/* @ts-ignore */}
          {children}
        </Content>
      </ModalContainer>
    </Overlay>
  )
}

export default BaseModal;